<template>
  <v-container fluid>
    <h4 class="mt-4 text-center">
      BẢNG PHÂN TÍCH HÓA ĐƠN {{ billType.toUpperCase() }}
      <span v-if="tableTitleDate">THÁNG {{ tableTitleDate }}</span>
    </h4>

    <v-layout justify-center align-center v-if="loader" style="min-height:200px">
      <v-progress-circular indeterminate color="primary" size="50" />
    </v-layout>

    <div v-else class="table-container">
       <v-data-table :items="displayingItems" hide-headers hide-actions class="custom-data-table">
        <template slot="items" slot-scope="props">
          <template v-if="props.item.isFirstHeaderRow">
            <tr class="text-no-wrap first-header">
              <td class="text-xs-center font-weight-bold" colSpan="2" style="background-color: #D3D3D3;"></td>
              <td class="text-xs-center font-weight-bold" colSpan="5" style="background-color: #D3D3D3;">Nhà nước</td>
              <td class="text-xs-center font-weight-bold" colSpan="6" style="background-color: #808080;">Khách trọ + bảo
                vệ</td>
              <td class="text-xs-center font-weight-bold" colSpan="3" style="background-color: #D3D3D3;">Chênh lệch
                tháng {{ chosen_month ? moment(chosen_month).format('M/YYYY') : '' }}</td>
              <td class="text-xs-center font-weight-bold" colSpan="3" style="background-color: #D3D3D3;">Chênh lệch
                tháng {{ chosen_month ? moment(chosen_month).subtract(1, 'month').format('M/YYYY') : '' }}</td>
              <td class="text-xs-center font-weight-bold" colSpan="3" style="background-color: #D3D3D3;">Chênh lệch
                tháng {{ chosen_month ? moment(chosen_month).subtract(2, 'month').format('M/YYYY') : '' }}</td>
              <td class="text-xs-center font-weight-bold" colSpan="1" style="background-color: #D3D3D3;">CL TB 2 tháng</td>
            </tr>
          </template>
          <template v-else-if="props.item.isSecondHeaderRow">
            <tr class="text-no-wrap second-header">
              <td class="text-xs-center font-weight-bold">Toà nhà</td>
              <td class="text-xs-center font-weight-bold">Mã KH</td>
              <td class="text-xs-right font-weight-bold">Số đầu kỳ</td>
              <td class="text-xs-right font-weight-bold">Số cuối kỳ</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #FCD6CC;">Số tiêu thụ</td>
              <td class="text-xs-right font-weight-bold">Đơn giá {{ billType ===
                'Nước' ? 'nước' : 'điện' }}</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #ADD8E6;">Số tiền đã nộp</td>
              <td class="text-xs-right font-weight-bold">Số tiêu thụ</td>
              <td class="text-xs-right font-weight-bold">Số tiêu thụ máy giặt</td>
              <td class="text-xs-right font-weight-bold">Số tiêu thụ bảo vệ</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #FCD6CC;">Tổng số tiêu thụ</td>
              <td class="text-xs-right font-weight-bold">Đơn giá</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #ADD8E6;">Số tiền đã thu</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #FCD6CC;">Số tiêu thụ</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #FCD6CC;">Tỷ lệ chênh lệch</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #ADD8E6;">Số tiền</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #FCD6CC;">Số tiêu thụ</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #FCD6CC;">Tỷ lệ chênh lệch</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #ADD8E6;">Số tiền</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #FCD6CC;">Số tiêu thụ</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #FCD6CC;">Tỷ lệ chênh lệch</td>
              <td class="text-xs-right font-weight-bold" style="background-color: #ADD8E6;">Số tiền</td>
              <td class="text-xs-center font-weight-bold" style="background-color: #FCD6CC;">Số tiêu thụ</td>
            </tr>
          </template>
          <template v-else>
            <td
              :class="{ 'text-center text-no-wrap': true, 'sub-row-cell': props.item.isSubRow, 'font-weight-bold': props.item.isTotalRow }">
              {{ props.item.building }}
            </td>
            <td
              :class="{ 'text-center text-no-wrap': true, 'sub-row-cell': props.item.isSubRow, 'font-weight-bold': props.item.isTotalRow }">
              {{ props.item.customer_code }}
            </td>

            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
              props.item.previous_period ? ($options.filters.formatNumber(props.item.previous_period)) : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
              props.item.current_period ? ($options.filters.formatNumber(props.item.current_period)) : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #FCD6CC;">{{
              props.item.state_consumption ? ($options.filters.formatNumber(props.item.state_consumption)) : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
              props.item.unit_price ? ($options.filters.formatNumber(Math.round(props.item.unit_price))) : ''
              }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #ADD8E6;">{{
              props.item.amount_paid ? ($options.filters.formatCurrency(props.item.amount_paid)) :
              '' }}</td>

            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow } ">{{
              props.item.tenant_consumption ? ($options.filters.formatNumber(props.item.tenant_consumption)) : '' }}
            </td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
              props.item.washing_consumption ? ($options.filters.formatNumber(props.item.washing_consumption)) : '' }}
            </td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
              props.item.security_consumption ? ($options.filters.formatNumber(props.item.security_consumption)) : '' }}
            </td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #FCD6CC;">{{
              props.item.total_consumption ? ($options.filters.formatNumber(props.item.total_consumption)) : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
              props.item.tenant_unit_price && props.item.total_consumption ?
              ($options.filters.formatNumber(props.item.tenant_unit_price)) : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #ADD8E6;">{{
              props.item.tenant_amount ? ($options.filters.formatCurrency(props.item.tenant_amount)) : '' }}</td>

            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #FCD6CC;">{{
              props.item.diff_consumption ? ($options.filters.formatNumber(props.item.diff_consumption)) : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #FCD6CC;">{{
              props.item.diff_rate ? (props.item.diff_rate + '%') : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #ADD8E6;">{{
              props.item.diff_amount ? ($options.filters.formatCurrency(props.item.diff_amount)) : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #FCD6CC;">{{
              props.item.diff_consumption_prev_month ?
              ($options.filters.formatNumber(props.item.diff_consumption_prev_month)) : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #FCD6CC;">{{
              props.item.diff_rate_prev_month ? (props.item.diff_rate_prev_month + '%') : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #ADD8E6;">{{
              props.item.diff_amount_prev_month ? ($options.filters.formatCurrency(props.item.diff_amount_prev_month)) :
              '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #FCD6CC;">{{
              props.item.diff_consumption_two_months_ago ?
              ($options.filters.formatNumber(props.item.diff_consumption_two_months_ago)) : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #FCD6CC;">{{
              props.item.diff_rate_two_months_ago ? (props.item.diff_rate_two_months_ago + '%') : '' }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
              style="background-color: #ADD8E6;">{{
              props.item.diff_amount_two_months_ago ?
              ($options.filters.formatCurrency(props.item.diff_amount_two_months_ago)) : '' }}</td>
              <td :class="{'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }"
                style="background-color: #FCD6CC;">{{
                props.item.avg_diff_consumption ? ($options.filters.formatNumber(props.item.avg_diff_consumption)) : '' }}</td>
          </template>
        </template>

        <template slot="no-data">
          Không có dữ liệu
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import api from 'Api';
import { buildParamQuery, formatCurrency, formatNumber } from "Helpers";
import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs';
import { INTERNAL_UTILITY_CONSUMER_TYPE, list_building } from 'Constants/db-config'
import moment from 'moment';

export default {
  name: 'table-phan-tich-dien-nuoc-theo-thang',
  props: {
    dateStart: {
      type: String,
      default: ''
    },
    dateEnd: {
      type: String,
      default: ''
    },
    billType: {
      type: String,
      default: 'Nước'
    },
    reloadTrigger: {
      type: Number,
      default: 0
    },
    export_csv: {
      type: Number,
      default: 0
    },
    chosen_month: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rawExtractedData: [],
      tenantAnalysisData: [],
      prevMonthRawExtractedData: [], // Dữ liệu nhà nước tháng trước
      prevMonthTenantAnalysisData: [],
      twoMonthsAgoRawExtractedData: [], // Dữ liệu nhà nước 2 tháng trước
      twoMonthsAgoTenantAnalysisData: [],
      tableTitleDate: '',
      loader: false,
      INTERNAL_UTILITY_CONSUMER_TYPE,
      list_building,
      formatCurrency,
      formatNumber,
      TENANT_UNIT_PRICE: {
        'Điện': 3400,
        'Nước': 20000
      },
      moment,
    };
  },
  filters: {
    formatDate(value) {
      if (!value) return '';
      const date = new Date(value);
      return date.toLocaleDateString('vi-VN');
    },
    formatMonthYear(value) {
      if (!value) return '';
      const date = new Date(value);
      return `${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    },
  },
  computed: {
    rooms() {
      return this.$store.state.app.rooms;
    },
    processBuildingData() {
      return (rawData, tenantData) => {
        const buildingGroups = {};

        this.list_building.map(item => item.value).forEach(buildingName => {
          buildingGroups[buildingName] = {
            tenant_consumption: 0,
            washing_consumption: 0,
            security_consumption: 0,
            total_consumption: 0,
            tenant_amount: 0,
            total_consumption_without_security: 0,
            total_state_consumption: 0,
            total_state_amount: 0,
            stateBills: [],
            tenant_unit_price: 0
          };

          const currentTenantConsumption = tenantData
            .filter(item => item.building === buildingName)
            .reduce((sum, item) => sum + (item.consumption || 0), 0);

          const buildingData = rawData.find(data => data.building === buildingName);

          if (buildingData) {
            buildingGroups[buildingName].tenant_unit_price = this.TENANT_UNIT_PRICE[this.billType] || 0;

            const washingConsumption = buildingData.internalBills
              .filter(bill => bill.consumer_type && bill.consumer_type.toLowerCase().includes(INTERNAL_UTILITY_CONSUMER_TYPE.WASHING_MACHINE.toLowerCase()))
              .reduce((sum, bill) => sum + (bill.consumption || 0), 0);
            const securityConsumption = buildingData.internalBills
              .filter(bill => bill.consumer_type && bill.consumer_type.toLowerCase().includes(INTERNAL_UTILITY_CONSUMER_TYPE.SECURITY_GUARD.toLowerCase()))
              .reduce((sum, bill) => sum + (bill.consumption || 0), 0);

            const totalInternalConsumption = washingConsumption + securityConsumption;
            const totalBuildingConsumption = currentTenantConsumption + totalInternalConsumption;
            const totalBuildingWithoutSecurityConsumption = currentTenantConsumption + washingConsumption;

            buildingGroups[buildingName].tenant_consumption += currentTenantConsumption;
            buildingGroups[buildingName].washing_consumption += washingConsumption;
            buildingGroups[buildingName].security_consumption += securityConsumption;
            buildingGroups[buildingName].total_consumption += totalBuildingConsumption;
            buildingGroups[buildingName].total_consumption_without_security += totalBuildingWithoutSecurityConsumption;
            buildingGroups[buildingName].tenant_amount = buildingGroups[buildingName].total_consumption_without_security * (buildingGroups[buildingName].tenant_unit_price || 0);

            buildingData.stateBills.forEach(stateBill => {
              buildingGroups[buildingName].total_state_consumption += stateBill.consumption || 0;
              buildingGroups[buildingName].total_state_amount += stateBill.amount_paid || 0;
              buildingGroups[buildingName].stateBills.push({
                building: stateBill.building,
                customer_code: stateBill.customer_code,
                previous_period: stateBill.previous_period,
                current_period: stateBill.current_period,
                state_consumption: stateBill.consumption,
                unit_price: stateBill.unit_price,
                amount_paid: stateBill.amount_paid
              });
            });
          } else {
            buildingGroups[buildingName].tenant_unit_price = this.TENANT_UNIT_PRICE[this.billType] || 0;

            const totalBuildingConsumption = currentTenantConsumption;
            const totalBuildingWithoutSecurityConsumption = currentTenantConsumption;

            buildingGroups[buildingName].tenant_consumption += currentTenantConsumption;
            buildingGroups[buildingName].total_consumption += totalBuildingConsumption;
            buildingGroups[buildingName].total_consumption_without_security += totalBuildingWithoutSecurityConsumption;
            buildingGroups[buildingName].tenant_amount = buildingGroups[buildingName].total_consumption_without_security * (buildingGroups[buildingName].tenant_unit_price || 0);
          }
        });
        return buildingGroups;
      };
    },

    buildingGroupsMap() {
      return this.processBuildingData(this.rawExtractedData, this.tenantAnalysisData);
    },
    prevMonthBuildingGroupsMap() {
      return this.processBuildingData(this.prevMonthRawExtractedData, this.prevMonthTenantAnalysisData);
    },
    twoMonthsAgoBuildingGroupsMap() {
      return this.processBuildingData(this.twoMonthsAgoRawExtractedData, this.twoMonthsAgoTenantAnalysisData);
    },

    processedItems() {
      const items = [];
      const buildingGroupsMap = this.buildingGroupsMap;
      const prevMonthBuildingGroupsMap = this.prevMonthBuildingGroupsMap;
      const twoMonthsAgoBuildingGroupsMap = this.twoMonthsAgoBuildingGroupsMap;

      this.list_building.map(item => item.value).forEach(buildingName => {
        const data = buildingGroupsMap[buildingName];
        const prevMonthData = prevMonthBuildingGroupsMap[buildingName] || {};
        const twoMonthsAgoData = twoMonthsAgoBuildingGroupsMap[buildingName] || {};

        if (data) {
          const hasStateBills = data.stateBills.length > 0;
          let isFirstRowForBuilding = true;

                     const diffConsumption = data.total_consumption - data.total_state_consumption;
           const diffRate = data.total_state_consumption > 0 ? Math.round((diffConsumption / data.total_consumption) * 100) : 0;
           const diffAmount = data.tenant_amount - data.total_state_amount;

           // Calculate previous month's difference
           const prevMonthDiffConsumption = (prevMonthData.total_consumption || 0) - (prevMonthData.total_state_consumption || 0);
           const prevMonthDiffRate = (prevMonthData.total_consumption || 0) > 0 ? Math.round((prevMonthDiffConsumption / (prevMonthData.total_consumption || 0)) * 100) : 0;
           const prevMonthDiffAmount = (prevMonthData.tenant_amount || 0) - (prevMonthData.total_state_amount || 0);

           // Calculate two months ago's difference
           const twoMonthsAgoDiffConsumption = (twoMonthsAgoData.total_consumption || 0) - (twoMonthsAgoData.total_state_consumption || 0);
           const twoMonthsAgoDiffRate = (twoMonthsAgoData.total_consumption || 0) > 0 ? Math.round((twoMonthsAgoDiffConsumption / (twoMonthsAgoData.total_consumption || 0)) * 100) : 0;
           const twoMonthsAgoDiffAmount = (twoMonthsAgoData.tenant_amount || 0) - (twoMonthsAgoData.total_state_amount || 0);

           const avgDiffConsumption = (diffConsumption + prevMonthDiffConsumption) / 2;

          if (hasStateBills) {
            data.stateBills.forEach(stateBill => {
              items.push({
                building: isFirstRowForBuilding ? buildingName : null,
                customer_code: stateBill.customer_code,
                previous_period: stateBill.previous_period,
                current_period: stateBill.current_period,
                state_consumption: stateBill.state_consumption,
                unit_price: stateBill.unit_price,
                amount_paid: stateBill.amount_paid,
                tenant_consumption: isFirstRowForBuilding ? data.tenant_consumption : null,
                washing_consumption: isFirstRowForBuilding ? data.washing_consumption : null,
                security_consumption: isFirstRowForBuilding ? data.security_consumption : null,
                total_consumption: isFirstRowForBuilding ? data.total_consumption : null,
                tenant_unit_price: isFirstRowForBuilding ? data.tenant_unit_price : null,
                tenant_amount: isFirstRowForBuilding ? data.tenant_amount : null,
                                 diff_consumption: isFirstRowForBuilding ? diffConsumption : null,
                 diff_rate: isFirstRowForBuilding ? diffRate : null,
                 diff_amount: isFirstRowForBuilding ? diffAmount : null,
                 diff_consumption_prev_month: isFirstRowForBuilding ? prevMonthDiffConsumption : null,
                 diff_rate_prev_month: isFirstRowForBuilding ? prevMonthDiffRate : null,
                 diff_amount_prev_month: isFirstRowForBuilding ? prevMonthDiffAmount : null,
                 diff_consumption_two_months_ago: isFirstRowForBuilding ? twoMonthsAgoDiffConsumption : null,
                 diff_rate_two_months_ago: isFirstRowForBuilding ? twoMonthsAgoDiffRate : null,
                 diff_amount_two_months_ago: isFirstRowForBuilding ? twoMonthsAgoDiffAmount : null,
                 avg_diff_consumption: isFirstRowForBuilding ? avgDiffConsumption : null,
                isSubRow: !isFirstRowForBuilding,
                isFirstHeaderRow: false,
                isSecondHeaderRow: false
              });
              isFirstRowForBuilding = false;
            });
          } else {
            items.push({
              building: buildingName,
              customer_code: null,
              previous_period: null,
              current_period: null,
              state_consumption: null,
              unit_price: null,
              amount_paid: null,
              tenant_consumption: data.tenant_consumption,
              washing_consumption: data.washing_consumption,
              security_consumption: data.security_consumption,
              total_consumption: data.total_consumption,
              tenant_unit_price: data.tenant_unit_price,
              tenant_amount: data.tenant_amount,
                             diff_consumption: diffConsumption,
               diff_rate: diffRate,
               diff_amount: diffAmount,
               diff_consumption_prev_month: prevMonthDiffConsumption,
               diff_rate_prev_month: prevMonthDiffRate,
               diff_amount_prev_month: prevMonthDiffAmount,
               diff_consumption_two_months_ago: twoMonthsAgoDiffConsumption,
               diff_rate_two_months_ago: twoMonthsAgoDiffRate,
               diff_amount_two_months_ago: twoMonthsAgoDiffAmount,
               avg_diff_consumption: avgDiffConsumption,
              isSubRow: false,
              isFirstHeaderRow: false,
              isSecondHeaderRow: false
            });
          }
        } else {
          items.push({
            building: buildingName,
            customer_code: null,
            previous_period: null,
            current_period: null,
            state_consumption: null,
            unit_price: null,
            amount_paid: null,
            tenant_consumption: null,
            washing_consumption: null,
            security_consumption: null,
            total_consumption: null,
            tenant_unit_price: null,
            tenant_amount: null,
                         diff_consumption: null,
             diff_rate: null,
             diff_amount: null,
             diff_consumption_prev_month: null,
             diff_rate_prev_month: null,
             diff_amount_prev_month: null,
             diff_consumption_two_months_ago: null,
             diff_rate_two_months_ago: null,
             diff_amount_two_months_ago: null,
            isSubRow: false,
            isFirstHeaderRow: false,
            isSecondHeaderRow: false
          });
        }
      });

      return items;
    },
    displayingItems() {
      if (!this.processedItems.length) return [];

      const items = [];
      items.push({ isFirstHeaderRow: true });
      items.push({ isSecondHeaderRow: true });
      items.push(...this.processedItems);

             // Calculate total differences for the total row
       const totalDiffConsumption = this.totalConsumption - this.totalStateConsumption;
       const totalDiffRate = this.totalStateConsumption > 0 ? Math.round((totalDiffConsumption / this.totalStateConsumption) * 100) : 0;
       const totalDiffAmount = this.totalTenantAmount - this.totalAmountPaid;

       // Totals for previous month and two months ago's "chênh lệch"
       const totalPrevMonthDiffConsumption = Object.values(this.prevMonthBuildingGroupsMap).reduce((sum, data) => sum + ((data.total_consumption || 0) - (data.total_state_consumption || 0)), 0);
       const totalPrevMonthDiffRate = Object.values(this.prevMonthBuildingGroupsMap).reduce((sum, data) => sum + (data.total_state_consumption || 0), 0) > 0 ? Math.round((totalPrevMonthDiffConsumption / Object.values(this.prevMonthBuildingGroupsMap).reduce((sum, data) => sum + (data.total_state_consumption || 0), 0)) * 100) : 0;
       const totalPrevMonthDiffAmount = Object.values(this.prevMonthBuildingGroupsMap).reduce((sum, data) => sum + ((data.tenant_amount || 0) - (data.total_state_amount || 0)), 0);

       const totalTwoMonthsAgoDiffConsumption = Object.values(this.twoMonthsAgoBuildingGroupsMap).reduce((sum, data) => sum + ((data.total_consumption || 0) - (data.total_state_consumption || 0)), 0);
       const totalTwoMonthsAgoDiffRate = Object.values(this.twoMonthsAgoBuildingGroupsMap).reduce((sum, data) => sum + (data.total_state_consumption || 0), 0) > 0 ? Math.round((totalTwoMonthsAgoDiffConsumption / Object.values(this.twoMonthsAgoBuildingGroupsMap).reduce((sum, data) => sum + (data.total_state_consumption || 0), 0)) * 100) : 0;
       const totalTwoMonthsAgoDiffAmount = Object.values(this.twoMonthsAgoBuildingGroupsMap).reduce((sum, data) => sum + ((data.tenant_amount || 0) - (data.total_state_amount || 0)), 0);

      const totalRow = {
        building: "Tổng",
        customer_code: null,
        previous_period: null,
        current_period: null,
        state_consumption: this.totalStateConsumption,
        unit_price: null,
        amount_paid: this.totalAmountPaid,
        tenant_consumption: this.totalTenantConsumption,
        washing_consumption: this.totalWashingConsumption,
        security_consumption: this.totalSecurityConsumption,
        total_consumption: this.totalConsumption,
        tenant_unit_price: null,
        tenant_amount: this.totalTenantAmount,
                 diff_consumption: totalDiffConsumption,
         diff_rate: totalDiffRate,
         diff_amount: totalDiffAmount,
         diff_consumption_prev_month: totalPrevMonthDiffConsumption,
         diff_rate_prev_month: totalPrevMonthDiffRate,
         diff_amount_prev_month: totalPrevMonthDiffAmount,
         diff_consumption_two_months_ago: totalTwoMonthsAgoDiffConsumption,
         diff_rate_two_months_ago: totalTwoMonthsAgoDiffRate,
         diff_amount_two_months_ago: totalTwoMonthsAgoDiffAmount,
        isTotalRow: true,
        isFirstHeaderRow: false,
        isSecondHeaderRow: false
      };

      items.push(totalRow);
      return items;
    },
    totalStateConsumption() {
      return Object.values(this.buildingGroupsMap).reduce((sum, data) => sum + (data.total_state_consumption || 0), 0);
    },
    totalAmountPaid() {
      return Object.values(this.buildingGroupsMap).reduce((sum, data) => sum + (data.total_state_amount || 0), 0);
    },
    totalTenantConsumption() {
      return Object.values(this.buildingGroupsMap).reduce((sum, data) => sum + (data.tenant_consumption || 0), 0);
    },
    totalWashingConsumption() {
      return Object.values(this.buildingGroupsMap).reduce((sum, data) => sum + (data.washing_consumption || 0), 0);
    },
    totalSecurityConsumption() {
      return Object.values(this.buildingGroupsMap).reduce((sum, data) => sum + (data.security_consumption || 0), 0);
    },
    totalConsumption() {
      return Object.values(this.buildingGroupsMap).reduce((sum, data) => sum + (data.total_consumption || 0), 0);
    },
    totalTenantAmount() {
      return Object.values(this.buildingGroupsMap).reduce((sum, data) => sum + (data.tenant_amount || 0), 0);
    },
    totalDiffConsumption() {
      return this.totalConsumption - this.totalStateConsumption;
    },
    totalDiffAmount() {
      return this.totalTenantAmount - this.totalAmountPaid;
    }
  },
  watch: {
    dateStart: 'fetchData',
    dateEnd: 'fetchData',
    billType: 'fetchData',
    reloadTrigger: 'fetchData',
    export_csv: 'exportXLSX'
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (!this.chosen_month || !this.billType) {
        this.rawExtractedData = [];
        this.tenantAnalysisData = [];
        this.prevMonthRawExtractedData = [];
        this.prevMonthTenantAnalysisData = [];
        this.twoMonthsAgoRawExtractedData = [];
        this.twoMonthsAgoTenantAnalysisData = [];
        return;
      }

      this.loader = true;
      this.$emit('loading', true);

      const currentMonthDate = new Date(this.chosen_month.substring(0, 7) + '-01');
      const prevMonthDate = new Date(currentMonthDate);
      prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);
      const twoMonthsAgoDate = new Date(currentMonthDate);
      twoMonthsAgoDate.setMonth(twoMonthsAgoDate.getMonth() - 2);

      const getCurrentMonthParams = (date) => ({
        dateStart: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`,
        dateEnd: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()}`,
        type: this.billType,
        month: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
      });

      const getAnalysisParams = (date) => {
        const targetDate = moment(date);
        let analysisStartDate, analysisEndDate;

        if (this.billType === 'Nước') {
          analysisStartDate = targetDate.clone().subtract(1, 'month').date(12);
          analysisEndDate = targetDate.clone().date(11);
        } else {
          analysisStartDate = targetDate.clone().startOf('month');
          analysisEndDate = targetDate.clone().endOf('month');
        }

        return {
          month: targetDate.format('YYYY-MM'),
          date_start: analysisStartDate.format('YYYY-MM-DD'),
          date_end: analysisEndDate.format('YYYY-MM-DD'),
          skip_previous_months_check: true
        };
      };

      const currentMonthDataPromises = [
        api.getBillsCombinedByBuilding(buildParamQuery(getCurrentMonthParams(currentMonthDate))),
        this.billType === 'Điện'
          ? api.getElectricityConsumptionAnalysis(buildParamQuery(getAnalysisParams(currentMonthDate)))
          : api.getWaterConsumptionAnalysis(buildParamQuery(getAnalysisParams(currentMonthDate)))
      ];

      const prevMonthDataPromises = [
        api.getBillsCombinedByBuilding(buildParamQuery(getCurrentMonthParams(prevMonthDate))),
        this.billType === 'Điện'
          ? api.getElectricityConsumptionAnalysis(buildParamQuery(getAnalysisParams(prevMonthDate)))
          : api.getWaterConsumptionAnalysis(buildParamQuery(getAnalysisParams(prevMonthDate)))
      ];

      const twoMonthsAgoDataPromises = [
        api.getBillsCombinedByBuilding(buildParamQuery(getCurrentMonthParams(twoMonthsAgoDate))),
        this.billType === 'Điện'
          ? api.getElectricityConsumptionAnalysis(buildParamQuery(getAnalysisParams(twoMonthsAgoDate)))
          : api.getWaterConsumptionAnalysis(buildParamQuery(getAnalysisParams(twoMonthsAgoDate)))
      ];

      try {
        const [
          currentRawData,
          currentTenantData,
          prevMonthRawData,
          prevMonthTenantData,
          twoMonthsAgoRawData,
          twoMonthsAgoTenantData
        ] = await Promise.all([
          ...currentMonthDataPromises,
          ...prevMonthDataPromises,
          ...twoMonthsAgoDataPromises
        ]);

        this.rawExtractedData = currentRawData.data.data || [];
        this.tenantAnalysisData = currentTenantData.data.filter(item => this.rooms.find(room => room.room_id === item.room_id)) || [];

        this.prevMonthRawExtractedData = prevMonthRawData.data.data || [];
        this.prevMonthTenantAnalysisData = prevMonthTenantData.data.filter(item => this.rooms.find(room => room.room_id === item.room_id)) || [];

        this.twoMonthsAgoRawExtractedData = twoMonthsAgoRawData.data.data || [];
        this.twoMonthsAgoTenantAnalysisData = twoMonthsAgoTenantData.data.filter(item => this.rooms.find(room => room.room_id === item.room_id)) || [];

        // Apply BMT to MT transformation to all fetched data
        const transformData = (dataArray) => {
          dataArray.forEach(item => {
            if (item.building === "BMT") {
              item.building = "MT";
            }
          });
        };

        transformData(this.rawExtractedData);
        transformData(this.tenantAnalysisData);
        transformData(this.prevMonthRawExtractedData);
        transformData(this.prevMonthTenantAnalysisData);
        transformData(this.twoMonthsAgoRawExtractedData);
        transformData(this.twoMonthsAgoTenantAnalysisData);

        this.tableTitleDate = this.$options.filters.formatMonthYear(this.chosen_month);

      } catch (error) {
        console.error("Lỗi khi lấy dữ liệu hóa đơn:", error);
        this.rawExtractedData = [];
        this.tenantAnalysisData = [];
        this.prevMonthRawExtractedData = [];
        this.prevMonthTenantAnalysisData = [];
        this.twoMonthsAgoRawExtractedData = [];
        this.twoMonthsAgoTenantAnalysisData = [];
      } finally {
        this.loader = false;
        this.$emit('loading', false);
      }
    },
    async exportXLSX() {
      if (!this.displayingItems.length) {
        alert('Không có dữ liệu để xuất Excel.');
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Phân tích điện nước');

      const title = `BẢNG PHÂN TÍCH HOÁ ĐƠN ${this.billType.toUpperCase()}`;
      const dateRange = this.tableTitleDate ? `Tháng ${this.tableTitleDate}` : '';
      const fullTitle = `${title} ${dateRange}`;
      
      worksheet.addRow([fullTitle]);
      worksheet.addRow([]);

      const headerRow1 = [
        '', '', 'NHÀ NƯỚC', '', '', '', '', 'KHÁCH TRỌ + BẢO VỆ', '', '', '', '', '', 
        `CHÊNH LỆCH THÁNG ${this.chosen_month ? moment(this.chosen_month).format('M/YYYY') : ''}`, '', '', 
        `CHÊNH LỆCH THÁNG ${this.chosen_month ? moment(this.chosen_month).subtract(1, 'month').format('M/YYYY') : ''}`, '', '', 
        `CHÊNH LỆCH THÁNG ${this.chosen_month ? moment(this.chosen_month).subtract(2, 'month').format('M/YYYY') : ''}`, '', '',
        'CL TB 2 THÁNG'
      ];
      
      const headerRow2 = [
        'TÒA NHÀ', 'MÃ KH', 'SỐ ĐẦU KỲ', 'SỐ CUỐI KỲ', 'SỐ TIÊU THỤ',
        `ĐƠN GIÁ ${this.billType === 'Nước' ? 'NƯỚC' : 'ĐIỆN'}`, 'SỐ TIỀN ĐÃ NỘP',
        'SỐ TIÊU THỤ', 'SỐ TIÊU THỤ MÁY GIẶT', 'SỐ TIÊU THỤ BẢO VỆ', 'TỔNG SỐ TIÊU THỤ',
        'ĐƠN GIÁ', 'SỐ TIỀN ĐÃ THU',
        'SỐ TIÊU THỤ', 'TỶ LỆ CHÊNH LỆCH', 'SỐ TIỀN',
        'SỐ TIÊU THỤ', 'TỶ LỆ CHÊNH LỆCH', 'SỐ TIỀN',
        'SỐ TIÊU THỤ', 'TỶ LỆ CHÊNH LỆCH', 'SỐ TIỀN',
        'SỐ TIÊU THỤ'
      ];

      worksheet.addRow(headerRow1);
      worksheet.addRow(headerRow2);

      const itemsToExport = this.displayingItems.filter(item => !item.isFirstHeaderRow && !item.isSecondHeaderRow);

      itemsToExport.forEach(item => {
        const formattedRow = [
          item.building,
          item.customer_code,
          item.previous_period,
          item.current_period,
          item.state_consumption,
          item.unit_price,
          item.amount_paid,
          item.tenant_consumption,
          item.washing_consumption,
          item.security_consumption,
          item.total_consumption,
          item.tenant_unit_price,
          item.tenant_amount,
          item.diff_consumption,
          item.diff_rate,
          item.diff_amount,
          item.diff_consumption_prev_month,
          item.diff_rate_prev_month,
          item.diff_amount_prev_month,
          item.diff_consumption_two_months_ago,
          item.diff_rate_two_months_ago,
          item.diff_amount_two_months_ago,
          item.avg_diff_consumption
        ];

        if (item.isTotalRow) {
          formattedRow[0] = 'TỔNG';
          formattedRow[1] = '';
        }

        worksheet.addRow(formattedRow);
      });

      worksheet.mergeCells('A1:W1');
      
      worksheet.mergeCells('C3:G3'); // NHÀ NƯỚC
      worksheet.mergeCells('H3:M3'); // KHÁCH TRỌ + BẢO VỆ
      worksheet.mergeCells('N3:P3'); // CHÊNH LỆCH THÁNG 1
      worksheet.mergeCells('Q3:S3'); // CHÊNH LỆCH THÁNG 2
      worksheet.mergeCells('T3:V3'); // CHÊNH LỆCH THÁNG 3
      worksheet.mergeCells('W3:W3'); // CL TB 2 THÁNG

        const titleCell = worksheet.getRow(1).getCell(1);
        titleCell.style = {
          font: { bold: true, size: 16, color: { argb: 'FF000000' } },
          alignment: { horizontal: 'center', vertical: 'middle' },
          border: {
            top: { style: 'none' },
            bottom: { style: 'none' },
            left: { style: 'none' },
            right: { style: 'none' }
          }
        };

      const headerRow1Style = {
        font: { bold: true, color: { argb: 'FF000000' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } },
        alignment: { horizontal: 'center', vertical: 'middle' },
        border: {
          top: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'thin', color: { argb: 'FF000000' } },
          left: { style: 'thin', color: { argb: 'FF000000' } },
          right: { style: 'thin', color: { argb: 'FF000000' } }
        }
      };

      for (let colNumber = 1; colNumber <= 23; colNumber++) {
        let cell = worksheet.getRow(3).getCell(colNumber);
        if (!cell.value && cell.value !== 0) {
          cell.value = '';
        }
        cell.style = headerRow1Style;
      }

      for (let colNumber = 1; colNumber <= 23; colNumber++) {
        let cell = worksheet.getRow(4).getCell(colNumber);
        if (!cell.value && cell.value !== 0) {
          cell.value = '';
        }

        let backgroundColor = 'FFFFFFFF';
        
        if (colNumber === 5 || colNumber === 11 || colNumber === 14 || colNumber === 15 || colNumber === 17 || colNumber === 18 || colNumber === 20 || colNumber === 21 || colNumber === 23) {
          backgroundColor = 'FFFCD6CC';
        }
        else if (colNumber === 7 || colNumber === 13 || colNumber === 16 || colNumber === 19 || colNumber === 22) {
          backgroundColor = 'FFADD8E6';
        }

        cell.style = {
          font: { bold: true, color: { argb: 'FF000000' } },
          fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: backgroundColor } },
          alignment: { horizontal: 'center', vertical: 'middle' },
          border: {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
          }
        };
      }

      for (let rowIndex = 5; rowIndex <= worksheet.rowCount; rowIndex++) {
        const row = worksheet.getRow(rowIndex);
        const isTotalRow = row.getCell(1).value === 'TỔNG';

        for (let colNumber = 1; colNumber <= 23; colNumber++) {
          let cell = row.getCell(colNumber);
          if (!cell.value && cell.value !== 0) {
            cell.value = '';
          }

          let backgroundColor = 'FFFFFFFF';
          
          if (colNumber === 5 || colNumber === 11 || colNumber === 14 || colNumber === 15 || colNumber === 17 || colNumber === 18 || colNumber === 20 || colNumber === 21 || colNumber === 23) {
            backgroundColor = 'FFFCD6CC';
          }
          else if (colNumber === 7 || colNumber === 13 || colNumber === 16 || colNumber === 19 || colNumber === 22) {
            backgroundColor = 'FFADD8E6';
          }

          cell.style = {
            font: { bold: isTotalRow, color: { argb: 'FF000000' } },
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: backgroundColor } },
            alignment: { horizontal: colNumber === 1 ? 'center' : (colNumber === 2 ? 'center' : 'right'), vertical: 'middle' },
            border: {
              top: { style: 'thin', color: { argb: 'FF000000' } },
              bottom: { style: 'thin', color: { argb: 'FF000000' } },
              left: { style: 'thin', color: { argb: 'FF000000' } },
              right: { style: 'thin', color: { argb: 'FF000000' } }
            }
          };
        }
      }

      const colWidths = [15, 12, 15, 15, 15, 18, 18, 15, 25, 25, 18, 15, 18, 15, 18, 18, 15, 18, 18, 15, 18, 18, 15];
      colWidths.forEach((width, index) => {
        worksheet.getColumn(index + 1).width = width;
      });

      for (let rowIndex = 1; rowIndex <= worksheet.rowCount; rowIndex++) {
        const row = worksheet.getRow(rowIndex);
        row.height = 30;
      }

      worksheet.views = [{ 
        state: 'frozen', 
        xSplit: 2,
        ySplit: 4
      }];

      const fileName = `${title.replace(/\s/g, '_')}_${dateRange.replace(/\s/g, '_').replace(/\//g, '-')}.xlsx`;

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    }
  }
};
</script>

<style scoped>
td, th {
  border: 1px solid #e0e0e0;
}

.table-container {
  overflow-x: auto;
}

.table-container table {
  border-collapse: collapse;
}

.table-analysis th {
  white-space: nowrap;
  font-weight: bold;
  border: 1px solid #000;
  height: auto !important;
  padding: 8px 16px;
}

.table-analysis td {
  border: 1px solid #000;
  vertical-align: top;
  padding: 8px 16px;
}

tr.first-header td:nth-child(1),
tr.second-header td:nth-child(1),
tr:not(.first-header):not(.second-header) td:nth-child(1) {
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: white;
}

tr.second-header td:nth-child(2),
tr:not(.first-header):not(.second-header) td:nth-child(2) {
  position: sticky;
  left: 100px;
  z-index: 1;
  background-color: white;
}

.table-analysis td.sub-row-cell {
  border-top: none;
  border-bottom: none;
  background-color: #f9f9f9;
}

.fw-bold {
  font-weight: bold;
}

.total-row-background {
  background-color: #f5f5f5;
}

.v-table__overflow{
  overflow: unset !important;
}

.custom-data-table {
  position: relative !important;
  max-height: 70vh !important;
  overflow-y: auto !important;
}

.custom-data-table >>> .v-table, .custom-data-table >>> .v-table__overflow, .custom-data-table >>> .v-data-table__wrapper {
  overflow: visible !important;
}

tr.first-header {
  position: sticky !important;
  top: 0 !important;
  z-index: 2 !important;
  background-color: white;
}

tr.second-header {
  position: sticky !important;
  top: 60px !important;
  z-index: 2 !important;
  background-color: white;
}
</style>